import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('changelog', app)
  return store
}
